import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  root: {
    padding: 25,
  },
  section: {
    border: '1px solid black',
    padding: '20px',
    margin: '10px 0',
  },
  dealerSelect: { marginTop: 30, marginLeft: 35, width: 200 },
  gridContainer: {
    paddingLeft: '30px !important',
    paddingRight: '30px !important',
    // marginTop: '30px !important',
  },
  paper: {
    border: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '5px !important',
    height: 'auto',
    padding: '50px',
  },
  dealerTypography: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  generateTemplateButton: {
    color: 'white !important',
    marginTop: '90px !important',
  },
  downloadButton: {
    marginLeft: 'auto !important',
    paddingRight: '30px !important',
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#f5f5f5',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  },

  modalActionButtonContainer: {
    float: 'right',
    marginRight: 5,
    marginTop: 35,
    marginBottom: 20,
  },
  modalCancelButton: {
    color: 'white !important',
    marginRight: '30px !important',
  },
  buttonSave: { color: 'white !important' },
  tabContainer: {
    marginTop: 30,
    borderBottom: 1,
    borderColor: 'divider',
    marginBottom: 10,
  },
  imageContainer: {
    maxHeight: 50,
    cursor: 'pointer',
    zIndex: 999,
  },
  modalHeader: {
    textAlign: 'center',
    marginBottom: '60px !important',
  },
  modalInputs: {
    marginBottom: '20px !important',
  },
  previewImageContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  folderName: {
    textAlign: 'end',
    color: '#666666',
  },
  navigationLink: {
    '&:visited': { color: 'black' },
    textDecoration: 'none',
  },
  modalButtonContainer: {
    display: 'flex !important',
    marginTop: '30px !important',
  },
  modalButton: {
    textTransform: "none",
    fontSize: "14px",
    // marginLeft: 'auto !important',
    color: 'white !important',
    marginRight: '20px !important',
  },
  modalButtonCancel: {
    textTransform: "none",
    fontSize: "14px",
    marginLeft: 'auto !important',
    color: 'black !important',
    marginRight: '8px !important',
  },
  modalButton2: {
    textTransform: "none",
    fontSize: "14px",
    color: "white"
  },
  rowUploadNameButton: {
    width: 'fit-content',
    minWidth: '600px',
    textAlign: 'left',
    color: 'black',
    textTransform: 'none',
    fontSize: '14px',
    justifyContent: 'flex-start',
  }
});
